import React, { Component } from 'react';
import {
  Icon,
  Segment,
  Step,
  Label,
  Button,
  Divider,
  Loader
} from 'semantic-ui-react';
import { toast } from 'react-toastify';
import {
  returnInitialLaunchState,
  returnIsAdReadyToLaunch,
  launchAd,
  countLaunchStatusesAndReturnStatusObject,
  returnFailedCollectionAdLaunchStatuses
} from './AdLibraryLaunchActions';
import AdLibraryLaunch from './AdLibraryLaunch';
import AdLibraryLaunchDestinationFieldsModal from './AdLibraryLaunchDestinationFieldsModal';
import CollectionToCinempraphSelectionModal from '../../../components/common/Launcher/CollectionToCinempraphSelectionModal';

class AdLibraryLaunchContainer extends Component {
  state = {
    activeStepIndex: 0,
    launchStatuses: [],
    launchStates: [],
    initialLaunchFired: false,
    debugLogContent: '',
    destinationFieldsModalOpen: false,
    isFailedCollectionAdModalOpen: false,
    idsOfCollectionAdsToConvert: [],
    collectionAdPrototypesToRelaunch: [],
    launchCount: 0
  };

  componentDidMount() {
    this.initializeLaunchObjects();
  }

  componentDidUpdate(prevProps, prevState) {
    const { launchCount: prevLaunchCount } = prevState;
    const { adPrototypesToLaunch } = this.props;
    const { launchCount } = this.state;
    if (
      prevLaunchCount !== adPrototypesToLaunch.length &&
      launchCount === adPrototypesToLaunch.length
    ) {
      setTimeout(() => {
        this.possiblyShowConvertCollectionsModal();
      }, 1500);
    }
  }

  initializeLaunchObjects = () => {
    const { adPrototypesToLaunch, getFbToken } = this.props;
    const token = getFbToken ? getFbToken() : '';
    const launchStatuses = adPrototypesToLaunch.map((adPrototype) => ({
      adPrototypeId: adPrototype.id,
      attemptedLaunches: 0,
      successfulLaunches: 0,
      failedLaunches: 0
    }));
    const launchStates = adPrototypesToLaunch.map((adPrototype) => ({
      adPrototypeId: adPrototype.id,
      state: returnInitialLaunchState(token, adPrototype.cards)
    }));
    this.setState(
      {
        ...this.state,
        launchStatuses,
        launchStates
      },
      () => {
        this.toggleDestinationFieldsModal(true);
      }
    );
  };

  possiblyShowConvertCollectionsModal = () => {
    const { adPrototypesToLaunch } = this.props;
    const failedCollectionAdStatuses = returnFailedCollectionAdLaunchStatuses(
      this.state.launchStatuses,
      adPrototypesToLaunch
    );
    if (failedCollectionAdStatuses.length > 0) {
      const collectionAdPrototypesToRelaunch = adPrototypesToLaunch.filter(
        (ad) =>
          failedCollectionAdStatuses.find(
            (adStatus) => adStatus.adPrototypeId === ad.id
          )
      );

      this.setState({
        ...this.state,
        isFailedCollectionAdModalOpen: true,
        collectionAdPrototypesToRelaunch
      });
    }
  };

  setLaunchStatusesState = (launchStatusArg) => {
    const { launchStatuses, launchCount } = this.state;
    const newLaunchStatuses = [...launchStatuses];
    const { adPrototypeId: adPrototypeIdToCompare } = launchStatusArg;
    const foundLaunchStatusObjIndex = launchStatuses.findIndex(
      (launchStatus) => launchStatus.adPrototypeId === adPrototypeIdToCompare
    );
    if (foundLaunchStatusObjIndex !== -1) {
      newLaunchStatuses.splice(foundLaunchStatusObjIndex, 1);
      newLaunchStatuses.push(launchStatusArg);
      this.setState((prevState) => ({
        ...prevState,
        launchStatuses: newLaunchStatuses,
        launchCount: launchCount + 1
      }));
    }
  };

  setLaunchStatesState = (
    adPrototypeIdToCompare,
    parametersObject,
    callback = null
  ) => {
    const { launchStates } = this.state;
    const newLaunchStates = [...launchStates];
    const foundIndex = launchStates.findIndex(
      (launchState) => launchState.adPrototypeId === adPrototypeIdToCompare
    );
    const parameterKeys = Object.keys(parametersObject);
    if (foundIndex !== -1) {
      parameterKeys.forEach((key) => {
        newLaunchStates[foundIndex].state[key] = parametersObject[key];
      });

      this.setState(
        (prevState) => ({
          ...prevState,
          launchStates: newLaunchStates
        }),
        callback
      );
    }
  };

  setActiveStepIndex = (index) => {
    const { adPrototypesToLaunch } = this.props;
    this.setState(
      (prevState) => ({
        ...prevState,
        activeStepIndex: index
      }),
      () => {
        const { launchStates } = this.state;
        const currentLaunchState = launchStates[index];
        const { state: currentState, adPrototypeId } = currentLaunchState;
        const matchingPrototype = adPrototypesToLaunch.find(
          (adPrototype) => adPrototype.id === adPrototypeId
        );
        const isCarousel = matchingPrototype.type === 'Carousel';
        if (isCarousel) {
          this.swapCardInputSurfaceValues(currentState);
        }
      }
    );
  };

  swapCardInputSurfaceValues = (currentState) => {
    try {
      const cardUrlInputs = document.getElementsByName('destinationUrl');
      const { form } = currentState;
      const { cards } = form;
      if (cardUrlInputs && cards && cards.length > 0) {
        cards.forEach((card, index) => {
          const { destinationUrl } = card;
          if (cardUrlInputs[index] && destinationUrl.length < 1) {
            cardUrlInputs[index].value = '';
          }
        });
      }
    } catch (error) {
      console.log('Error in swapCardInputSurfaceValues():', error);
    }
  };

  renderAdLaunchStep = (index, adPrototype) => {
    const { activeStepIndex, launchStatuses, launchStates } = this.state;
    const { id, name: adName, type: adType } = adPrototype;
    const launchStatus =
      launchStatuses.find((status) => status.adPrototypeId === id) || {};
    const launchStateObject =
      launchStates.find((state) => state.adPrototypeId === id) || {};
    const { state: currentState } = launchStateObject || {};

    const isLaunchInProgress = currentState ? currentState.processing : false;
    let wasLaunchSuccessful = false;
    let waslaunchFailure = false;

    if (launchStatus) {
      const {
        attemptedLaunches,
        successfulLaunches,
        failedLaunches
      } = launchStatus;
      wasLaunchSuccessful =
        attemptedLaunches !== 0 &&
        successfulLaunches === attemptedLaunches &&
        !isLaunchInProgress;
      waslaunchFailure =
        attemptedLaunches !== 0 &&
        failedLaunches === attemptedLaunches &&
        !isLaunchInProgress;
    }
    return (
      <Step
        completed={wasLaunchSuccessful && !isLaunchInProgress}
        active={activeStepIndex === index}
        onClick={() => this.setActiveStepIndex(index)}
      >
        {isLaunchInProgress ? <Loader inline active /> : null}
        {waslaunchFailure ? (
          <Icon name="close" color="red" />
        ) : (
          <Icon name={isLaunchInProgress ? '' : 'rocket'} />
        )}
        <Step.Content>
          <Step.Title style={{ wordWrap: 'anywhere', wordBreak: 'break-word' }}>
            {adName}
          </Step.Title>
          <Step.Description>
            {adType}
            {this.renderLaunchStatusProgress(launchStatus || {})}
          </Step.Description>
        </Step.Content>
      </Step>
    );
  };

  renderLaunchStatusProgress = (launchStatus) => {
    const {
      attemptedLaunches,
      successfulLaunches,
      failedLaunches
    } = launchStatus;
    const showProgress = launchStatus && attemptedLaunches !== 0;

    if (showProgress) {
      const successProgress = `${successfulLaunches} / ${attemptedLaunches}`;
      const failProgress = `${failedLaunches} / ${attemptedLaunches}`;
      return (
        <Segment basic compact style={{ padding: 0 }}>
          <Label.Group size="mini">
            {successfulLaunches > 0 ? (
              <Label color="green" content={successProgress} />
            ) : null}
            {failedLaunches > 0 ? (
              <Label color="red" content={failProgress} />
            ) : null}
          </Label.Group>
        </Segment>
      );
    }
    return null;
  };

  renderAdLaunchSegmentContent = (
    currentAdPrototype,
    currentLaunchStateObject,
    currentLaunchStatusObject
  ) => {
    const { debugLogContent, idsOfCollectionAdsToConvert } = this.state;
    const {
      user,
      searchPage,
      adType,
      adPrototypesTags,
      accountOptions,
      getFbToken,
      canvases,
      productCatalogs
    } = this.props;
    const currentLaunchState = currentLaunchStateObject
      ? currentLaunchStateObject.state
      : null;
    const needToRelaunchAd = currentLaunchStatusObject
      ? currentLaunchStatusObject.failedLaunches > 0
      : false;

    if (currentLaunchState) {
      return (
        <AdLibraryLaunch
          user={user}
          searchPage={searchPage}
          adType={adType}
          adPrototypesTags={adPrototypesTags}
          accounts={accountOptions}
          getFbToken={getFbToken}
          canvases={canvases}
          adPrototype={currentAdPrototype}
          productCatalogs={productCatalogs}
          launchAdFromParent={this.launchAd}
          setLaunchStatusesState={this.setLaunchStatusesState}
          launchStateFromParent={currentLaunchState}
          setLaunchStateInParent={this.setLaunchStatesState}
          debugLogContent={debugLogContent}
          needToRelaunchAd={needToRelaunchAd}
          idsOfCollectionAdsToConvert={idsOfCollectionAdsToConvert}
          alterIdsOfCollectionAdsToConvert={
            this.alterIdsOfCollectionAdsToConvert
          }
        />
      );
    }
    return null;
  };

  renderMultiLaunchButton = () => {
    const { launchStates, initialLaunchFired } = this.state;
    const isLaunchReady = this.checkIfMultiLaunchIsReady();
    const isLaunchInProgress = this.returnIslaunchInProgress();
    const numberOfPrototypes = launchStates.length;
    return (
      <div className="sticky-tools" style={{ right: '1.5em' }}>
        <Segment compact basic>
          <Button
            disabled={
              !isLaunchReady || isLaunchInProgress || initialLaunchFired
            }
            loading={isLaunchInProgress && !initialLaunchFired}
            icon
            labelPosition="left"
            size="large"
            color="green"
            circular
            style={{
              float: 'right',
              margin: 0
            }}
            onClick={() => {
              this.launchAllAds();
            }}
          >
            <Icon name="rocket" />
            {`Launch ${numberOfPrototypes} ${
              numberOfPrototypes > 1 ? 'ads' : 'ad'
            }`}
          </Button>
        </Segment>
      </div>
    );
  };

  checkIfMultiLaunchIsReady = () => {
    const { launchStates } = this.state;
    const { adPrototypesToLaunch } = this.props;
    let isLaunchReady = false;
    try {
      const numberOfPrototypes = adPrototypesToLaunch.length;
      const readyStatusArray = launchStates.map((launchState) => {
        const { adPrototypeId, state: currentState } = launchState;
        const { form } = currentState || {};
        const foundAdPrototype = adPrototypesToLaunch.find(
          (adPrototype) => adPrototype.id === adPrototypeId
        );
        const { type } = foundAdPrototype || {};
        const isAdReadyToLaunch = returnIsAdReadyToLaunch(type, form);
        return isAdReadyToLaunch;
      });
      const readyAdStatuses = readyStatusArray
        ? readyStatusArray.filter((readyStatus) => readyStatus)
        : [];
      const numberOfLaunchableAds = readyAdStatuses.length;
      isLaunchReady = numberOfLaunchableAds === numberOfPrototypes;
    } catch (error) {
      console.log(
        'Something went wrong in checkIfMultiLaunchIsReady():',
        error
      );
    }
    return isLaunchReady;
  };

  launchAllAds = (adPrototypes) => {
    const { adPrototypesToLaunch } = this.props;
    this.setState(
      (prevState) => ({
        ...prevState,
        initialLaunchFired: true,
        launchCount: 0
      }),
      async () => {
        await Promise.all(
          (adPrototypes || adPrototypesToLaunch).map(async (adPrototype) => {
            await this.launchAd(adPrototype);
          })
        );
      }
    );
  };

  relaunchAllAds = () => {
    const { adPrototypesToLaunch } = this.props;

    const filteredAdPrototypes = adPrototypesToLaunch.filter((adPrototype) => {
      const matchingStatus = this.state.launchStatuses.find(
        (launchStatus) => launchStatus.adPrototypeId === adPrototype.id
      );
      return matchingStatus && matchingStatus.failedLaunches > 0;
    });

    this.launchAllAds(filteredAdPrototypes);
  };

  launchAd = async (inputAdPrototype) => {
    const adPrototype = { ...inputAdPrototype };
    const { id: adPrototypeId, type } = adPrototype;
    if (type === 'Collection') {
      adPrototype.convertToCinemagraph = !!this.state.idsOfCollectionAdsToConvert.find(
        (id) => id === adPrototypeId
      );
    }
    let currentLaunchState = {};
    this.setLaunchStatesState(
      adPrototypeId,
      {
        log: '',
        processing: true,
        debugLogOpen: true
      },
      async () => {
        currentLaunchState = this.getCurrentLaunchState(adPrototypeId);
        const {
          token,
          form,
          thumbnails,
          currentThumbnail,
          campaign_ids: selectedCampaigns
        } = currentLaunchState;
        const adLibraryLaunchCard = {
          state: { currentThumbnail }
        };
        const adLibraryLaunchFieldsComponent = {
          state: { thumbnails }
        };

        form.selectedCampaigns = selectedCampaigns;

        const launchAdResult = await launchAd(
          token,
          form,
          adPrototype,
          adLibraryLaunchCard,
          adLibraryLaunchFieldsComponent
        );

        const { data: launchAdResultData, message: launchAdResultMessage } =
          launchAdResult || {};

        let launchStatusObj;
        let logMessage = '';

        if (
          !launchAdResultData ||
          (launchAdResultData && launchAdResultData.length < 1)
        ) {
          launchStatusObj = {
            error: {
              error_user_title: 'Unknown error',
              error_user_msg: 'No launch data was returned'
            }
          };
          logMessage = `AD: ${adPrototype.adName}: Failed. Unknown error: No launch data was returned. Check if the selected adsets are valid, refresh the page, and try again \n`;
        } else {
          logMessage = launchAdResultMessage;
          launchStatusObj = countLaunchStatusesAndReturnStatusObject(
            adPrototypeId,
            launchAdResultData
          );
        }

        const newDebugLogText = `${this.state.debugLogContent}\n${logMessage}`;

        this.setState(
          (prevState) => ({
            ...prevState,
            debugLogContent: newDebugLogText
          }),
          () => {
            this.setLaunchStatesState(
              adPrototypeId,
              {
                processing: false,
                debugLogOpen: true,
                log: logMessage,
                launchStatus: launchStatusObj
              },
              () => {
                currentLaunchState = this.getCurrentLaunchState(adPrototypeId);
                const { launchStatus } = currentLaunchState;
                toast.info(`Launch process for ${adPrototype.name} complete`, {
                  position: 'top-right',
                  autoClose: 3500,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true
                });
                this.setLaunchStatusesState(launchStatus);
              }
            );
          }
        );
      }
    );
  };

  getCurrentLaunchState = (adPrototypeId) => {
    const { launchStates } = this.state;
    const foundLaunchStatusObject = launchStates.find(
      (launchStateObj) => launchStateObj.adPrototypeId === adPrototypeId
    );
    const { state: currentLaunchState } = foundLaunchStatusObject || {};
    return currentLaunchState || {};
  };

  returnIslaunchInProgress = () => {
    const { launchStates } = this.state;
    let isLaunchInProgress = false;
    const stateWithProcessing = launchStates.find((launchStateObj) => {
      const { state: currentState } = launchStateObj;
      const { processing } = currentState;
      return processing;
    });
    if (stateWithProcessing) {
      isLaunchInProgress = true;
    }
    return isLaunchInProgress;
  };

  toggleDestinationFieldsModal = (bool) => {
    this.setState((prevState) => ({
      ...prevState,
      destinationFieldsModalOpen: bool
    }));
  };

  fillDestininationFieldsForEachAd = (fillParams) => {
    const newStateParams = { ...fillParams };

    this.batchSetLaunchStates(newStateParams);
    toast.info(
      `Destination field values have been applied to all ad prototypes`,
      {
        position: 'bottom-center',
        autoClose: 3500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      }
    );
  };

  batchSetLaunchStates = (parametersObject, callback = null) => {
    const { launchStates } = this.state;
    for (const launchStateObj of launchStates) {
      const { adPrototypeId, state } = launchStateObj;
      const foundAdPrototype = this.props.adPrototypesToLaunch.find(
        (adPrototype) => adPrototype.id === adPrototypeId
      );
      if (!foundAdPrototype) {
        continue;
      }
      const newLaunchState = Object.assign({}, state);
      for (const key in parametersObject) {
        if (key === 'form') {
          for (const formKey in parametersObject.form) {
            if (formKey === 'adsets') {
              newLaunchState.form[formKey] = parametersObject.form[formKey].map(
                (item) => {
                  const newObject = Object.assign({}, item);
                  return newObject;
                }
              );
            } else if (key === 'productSet' || key === 'productCatalog') {
              newLaunchState.form[formKey] =
                foundAdPrototype && foundAdPrototype.type === 'Collection'
                  ? parametersObject.form[formKey]
                  : '';
            } else {
              newLaunchState.form[formKey] = parametersObject.form[formKey];
            }
          }
        } else if (key === 'selectedPage') {
          if (parametersObject[key].pageId) {
            newLaunchState[key] = Object.assign({}, parametersObject[key]);
          }
        } else if (
          key === 'campaign_ids' ||
          key === 'filteredCampaigns' ||
          key === 'campaigns' ||
          key === 'data'
        ) {
          newLaunchState[key] = parametersObject[key].map((item) => {
            const newObject = Object.assign({}, item);
            return newObject;
          });
        } else if (key === 'productSets') {
          newLaunchState[key] =
            foundAdPrototype && foundAdPrototype.type === 'Collection'
              ? parametersObject[key]
              : [];
        } else {
          newLaunchState[key] = parametersObject[key];
        }
      }

      this.setLaunchStatesState(adPrototypeId, newLaunchState, callback);
    }
  };

  alterIdsOfCollectionAdsToConvert = (adPrototypeId) => {
    const { idsOfCollectionAdsToConvert } = this.state;
    const newIds = idsOfCollectionAdsToConvert.includes(adPrototypeId)
      ? idsOfCollectionAdsToConvert.filter((id) => id !== adPrototypeId)
      : [...idsOfCollectionAdsToConvert, adPrototypeId];
    this.setState((prevState) => ({
      ...prevState,
      idsOfCollectionAdsToConvert: newIds
    }));
  };

  render() {
    const {
      adPrototypesToLaunch,
      searchPage,
      getFbToken,
      accountOptions,
      productCatalogs,
      user
    } = this.props;
    const {
      activeStepIndex,
      launchStates,
      launchStatuses,
      destinationFieldsModalOpen,
      isFailedCollectionAdModalOpen,
      idsOfCollectionAdsToConvert,
      collectionAdPrototypesToRelaunch
    } = this.state;
    const currentAdPrototype = adPrototypesToLaunch[activeStepIndex] || {};
    if (currentAdPrototype.id) {
      const currentLaunchStateObject = launchStates.find(
        (launchStateObj) =>
          launchStateObj.adPrototypeId === currentAdPrototype.id
      );
      const currentLaunchStatusObject = launchStatuses.find(
        (launchStateObj) =>
          launchStateObj.adPrototypeId === currentAdPrototype.id
      );
      const isLaunchInProgress = this.returnIslaunchInProgress();
      return (
        <div>
          <Button onClick={searchPage} size="small" color="grey">
            Back
          </Button>
          <Divider hidden />
          <Segment basic style={{ padding: 0 }}>
            <Step.Group
              attached="top"
              fluid
              widths={adPrototypesToLaunch.length}
              className={
                adPrototypesToLaunch.length > 5
                  ? 'ad-launcher-segment-header'
                  : ''
              }
            >
              {adPrototypesToLaunch.map((adPrototype, index) =>
                this.renderAdLaunchStep(index, adPrototype)
              )}
            </Step.Group>
            <Segment attached style={{ paddingBottom: 0 }}>
              {this.renderAdLaunchSegmentContent(
                currentAdPrototype,
                currentLaunchStateObject,
                currentLaunchStatusObject
              )}
            </Segment>
            <Label
              as="a"
              color="blue"
              size="big"
              floating
              circular
              className={isLaunchInProgress ? 'disabled' : ''}
              onClick={() => this.toggleDestinationFieldsModal(true)}
            >
              <Icon name="copy" style={{ margin: 0 }} />
            </Label>
          </Segment>
          <Divider hidden />
          {this.renderMultiLaunchButton()}
          <AdLibraryLaunchDestinationFieldsModal
            user={user}
            openModal={destinationFieldsModalOpen}
            getFbToken={getFbToken}
            accounts={accountOptions}
            toggleDestinationFieldsModal={this.toggleDestinationFieldsModal}
            fillDestininationFieldsForEachAd={
              this.fillDestininationFieldsForEachAd
            }
            launchIncludesCollectionAds={
              adPrototypesToLaunch.filter(
                (adPrototype) => adPrototype.type === 'Collection'
              ).length > 0
            }
            productCatalogs={productCatalogs}
          />
          <CollectionToCinempraphSelectionModal
            openModal={isFailedCollectionAdModalOpen}
            toggleModal={(toggleValue) => {
              this.setState((prevState) => ({
                ...prevState,
                isFailedCollectionAdModalOpen: toggleValue
              }));
            }}
            collectionAdPrototypes={collectionAdPrototypesToRelaunch}
            idsOfCollectionAdsToConvert={idsOfCollectionAdsToConvert}
            alterIdsOfCollectionAdsToConvert={
              this.alterIdsOfCollectionAdsToConvert
            }
            fireRelaunch={this.relaunchAllAds}
          />
        </div>
      );
    }
    return (
      <div>Something went wrong. Go back to Ad Library and try again.</div>
    );
  }
}

export default AdLibraryLaunchContainer;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdLibraryLaunchContainer.js